import api from "./axiosInstance";

/**
 * CRM Lead APIs
 */
export const crmLeadApi = {
  getAll: (params = {}) => api.get("/crm/leads", { params }),
  getById: (id) => api.get(`/crm/leads/${id}`),
  create: (data) => api.post("/crm/leads", data),
  update: (id, data) => api.put(`/crm/leads/${id}`, data),
  delete: (id) => api.delete(`/crm/leads/${id}`),
  assign: (id, data) => api.post(`/crm/leads/${id}/assign`, data),
  reassign: (id, data) => api.post(`/crm/leads/${id}/reassign`, data),
  convert: (id, data) => api.post(`/crm/leads/${id}/convert`, data),
  markLost: (id, data) => api.post(`/crm/leads/${id}/lost`, data),
  getActivities: (id, params = {}) => api.get(`/crm/leads/${id}/activities`, { params }),
  addActivity: (id, data) => api.post(`/crm/leads/${id}/activities`, data),
  getCalls: (id, params = {}) => api.get(`/crm/leads/${id}/calls`, { params }),
  addCall: (id, data) => api.post(`/crm/leads/${id}/calls`, data),
  getFollowups: (id, params = {}) => api.get(`/crm/leads/${id}/followups`, { params }),
  addFollowup: (id, data) => api.post(`/crm/leads/${id}/followups`, data),
  getWhatsAppMessages: (id, params = {}) => api.get(`/crm/leads/${id}/whatsapp`, { params }),
  sendWhatsApp: (id, data) => api.post(`/crm/leads/${id}/whatsapp`, data),
  createOpportunity: (id, data) => api.post(`/crm/leads/${id}/opportunities`, data),
  createQuotation: (id, data) => api.post(`/crm/leads/${id}/quotations`, data),
};

/**
 * CRM My Leads APIs (for salesperson)
 */
export const crmMyLeadsApi = {
  getAll: (params = {}) => api.get("/crm/my-leads", { params }),
  getStats: () => api.get("/crm/my-leads/stats"),
};

/**
 * CRM IndiaMART Lead APIs
 */
export const crmIndiaMartLeadApi = {
  getAll: (params = {}) => api.get("/crm/india-mart/leads", { params }),
  getById: (id) => api.get(`/crm/india-mart/leads/${id}`),
  sync: () => api.post("/crm/india-mart/sync"),
  getSettings: () => api.get("/crm/india-mart/settings"),
  updateSettings: (data) => api.put("/crm/india-mart/settings", data),
  testConnection: () => api.post("/crm/india-mart/test-connection"),
  disconnect: () => api.post("/crm/india-mart/disconnect"),
};

/**
 * CRM Company APIs
 */
export const crmCompanyApi = {
  getAll: (params = {}) => api.get("/crm/companies", { params }),
  getById: (id) => api.get(`/crm/companies/${id}`),
  create: (data) => api.post("/crm/companies", data),
  update: (id, data) => api.put(`/crm/companies/${id}`, data),
  delete: (id) => api.delete(`/crm/companies/${id}`),
  getContacts: (id, params = {}) => api.get(`/crm/companies/${id}/contacts`, { params }),
  getLeads: (id, params = {}) => api.get(`/crm/companies/${id}/leads`, { params }),
  getOpportunities: (id, params = {}) => api.get(`/crm/companies/${id}/opportunities`, { params }),
};

/**
 * CRM Contact APIs
 */
export const crmContactApi = {
  getAll: (params = {}) => api.get("/crm/contacts", { params }),
  getById: (id) => api.get(`/crm/contacts/${id}`),
  create: (data) => api.post("/crm/contacts", data),
  update: (id, data) => api.put(`/crm/contacts/${id}`, data),
  delete: (id) => api.delete(`/crm/contacts/${id}`),
};

/**
 * CRM Follow-up APIs
 */
export const crmFollowupApi = {
  getAll: (params = {}) => api.get("/crm/followups", { params }),
  getById: (id) => api.get(`/crm/followups/${id}`),
  create: (data) => api.post("/crm/followups", data),
  update: (id, data) => api.put(`/crm/followups/${id}`, data),
  delete: (id) => api.delete(`/crm/followups/${id}`),
  complete: (id, data) => api.post(`/crm/followups/${id}/complete`, data),
  reschedule: (id, data) => api.post(`/crm/followups/${id}/reschedule`, data),
  getToday: () => api.get("/crm/followups/today"),
  getUpcoming: (params = {}) => api.get("/crm/followups/upcoming", { params }),
  getOverdue: () => api.get("/crm/followups/overdue"),
  getCalendar: (params = {}) => api.get("/crm/followups/calendar", { params }),
};

/**
 * CRM Call APIs
 */
export const crmCallApi = {
  getAll: (params = {}) => api.get("/crm/calls", { params }),
  getById: (id) => api.get(`/crm/calls/${id}`),
  create: (data) => api.post("/crm/calls", data),
  update: (id, data) => api.put(`/crm/calls/${id}`, data),
  delete: (id) => api.delete(`/crm/calls/${id}`),
  getToday: () => api.get("/crm/calls/today"),
};

/**
 * CRM Opportunity APIs
 */
export const crmOpportunityApi = {
  getAll: (params = {}) => api.get("/crm/opportunities", { params }),
  getById: (id) => api.get(`/crm/opportunities/${id}`),
  create: (data) => api.post("/crm/opportunities", data),
  update: (id, data) => api.put(`/crm/opportunities/${id}`, data),
  delete: (id) => api.delete(`/crm/opportunities/${id}`),
  updateStage: (id, data) => api.put(`/crm/opportunities/${id}/stage`, data),
  markWon: (id, data) => api.post(`/crm/opportunities/${id}/won`, data),
  markLost: (id, data) => api.post(`/crm/opportunities/${id}/lost`, data),
  convertToCustomer: (id, data) => api.post(`/crm/opportunities/${id}/convert`, data),
  getQuotations: (id, params = {}) => api.get(`/crm/opportunities/${id}/quotations`, { params }),
  linkQuotation: (id, data) => api.post(`/crm/opportunities/${id}/quotations`, data),
};

/**
 * CRM Pipeline Stage APIs
 */
export const crmPipelineStageApi = {
  getAll: () => api.get("/crm/pipeline-stages"),
  create: (data) => api.post("/crm/pipeline-stages", data),
  update: (id, data) => api.put(`/crm/pipeline-stages/${id}`, data),
  delete: (id) => api.delete(`/crm/pipeline-stages/${id}`),
  reorder: (data) => api.post("/crm/pipeline-stages/reorder", data),
};

/**
 * CRM WhatsApp APIs
 */
export const crmWhatsAppApi = {
  getConversations: (params = {}) => api.get("/crm/whatsapp/conversations", { params }),
  getConversationById: (id) => api.get(`/crm/whatsapp/conversations/${id}`),
  getMessages: (conversationId, params = {}) => api.get(`/crm/whatsapp/conversations/${conversationId}/messages`, { params }),
  sendMessage: (data) => api.post("/crm/whatsapp/messages", data),
  sendTemplate: (data) => api.post("/crm/whatsapp/send-template", data),
  markAsRead: (conversationId) => api.post(`/crm/whatsapp/conversations/${conversationId}/read`),
  getTemplates: (params = {}) => api.get("/crm/whatsapp/templates", { params }),
  createTemplate: (data) => api.post("/crm/whatsapp/templates", data),
  updateTemplate: (id, data) => api.put(`/crm/whatsapp/templates/${id}`, data),
  deleteTemplate: (id) => api.delete(`/crm/whatsapp/templates/${id}`),
  submitTemplate: (id) => api.post(`/crm/whatsapp/templates/${id}/submit`),
};

/**
 * CRM Bulk Message / Campaign APIs
 */
export const crmCampaignApi = {
  getAll: (params = {}) => api.get("/crm/campaigns", { params }),
  getById: (id) => api.get(`/crm/campaigns/${id}`),
  create: (data) => api.post("/crm/campaigns", data),
  update: (id, data) => api.put(`/crm/campaigns/${id}`, data),
  delete: (id) => api.delete(`/crm/campaigns/${id}`),
  send: (id) => api.post(`/crm/campaigns/${id}/send`),
  schedule: (id, data) => api.post(`/crm/campaigns/${id}/schedule`, data),
  getRecipients: (id, params = {}) => api.get(`/crm/campaigns/${id}/recipients`, { params }),
  addRecipients: (id, data) => api.post(`/crm/campaigns/${id}/recipients`, data),
  getAnalytics: (id) => api.get(`/crm/campaigns/${id}/analytics`),
};

/**
 * CRM Marketing Campaign APIs (New Customer, Product Arrival, Special Offer)
 */
export const crmMarketingCampaignApi = {
  getAll: (params = {}) => api.get("/crm/marketing-campaigns", { params }),
  getById: (id) => api.get(`/crm/marketing-campaigns/${id}`),
  create: (data) => api.post("/crm/marketing-campaigns", data),
  update: (id, data) => api.put(`/crm/marketing-campaigns/${id}`, data),
  delete: (id) => api.delete(`/crm/marketing-campaigns/${id}`),
  send: (id) => api.post(`/crm/marketing-campaigns/${id}/send`),
  schedule: (id, data) => api.post(`/crm/marketing-campaigns/${id}/schedule`, data),
  getMessages: (id, page = 0, size = 50) => api.get(`/crm/marketing-campaigns/${id}/messages`, { params: { page, size } }),
  getAnalytics: (id) => api.get(`/crm/marketing-campaigns/${id}/analytics`),
  addRecipients: (id, data) => api.post(`/crm/marketing-campaigns/${id}/recipients`, data),
};

/**
 * CRM Dashboard APIs
 */
export const crmDashboardApi = {
  getStats: () => api.get("/crm/dashboard/stats"),
  getLeadSourceDistribution: () => api.get("/crm/dashboard/lead-source-distribution"),
  getSalesFunnel: () => api.get("/crm/dashboard/sales-funnel"),
  getMonthlyLeadTrend: (params = {}) => api.get("/crm/dashboard/monthly-lead-trend", { params }),
  getSalespersonActivity: (params = {}) => api.get("/crm/dashboard/salesperson-activity", { params }),
  getQuotationConversion: () => api.get("/crm/dashboard/quotation-conversion"),
  getLeadConversion: () => api.get("/crm/dashboard/lead-conversion"),
  getTodaysFollowups: () => api.get("/crm/dashboard/todays-followups"),
  getRecentIndiaMartLeads: (params = {}) => api.get("/crm/dashboard/recent-indiamart-leads", { params }),
  getRecentCalls: (params = {}) => api.get("/crm/dashboard/recent-calls", { params }),
  getRecentActivities: (params = {}) => api.get("/crm/dashboard/recent-activities", { params }),
  getOpenOpportunities: (params = {}) => api.get("/crm/dashboard/open-opportunities", { params }),
};

/**
 * CRM Reports APIs
 */
export const crmReportsApi = {
  getLeadSourceReport: (params = {}) => api.get("/crm/reports/lead-source", { params }),
  getIndiaMartLeadReport: (params = {}) => api.get("/crm/reports/india-mart", { params }),
  getSalespersonPerformance: (params = {}) => api.get("/crm/reports/salesperson-performance", { params }),
  getCallReport: (params = {}) => api.get("/crm/reports/calls", { params }),
  getFollowupReport: (params = {}) => api.get("/crm/reports/followups", { params }),
  getWhatsAppReport: (params = {}) => api.get("/crm/reports/whatsapp", { params }),
  getOpportunityReport: (params = {}) => api.get("/crm/reports/opportunities", { params }),
  getQuotationConversion: (params = {}) => api.get("/crm/reports/quotation-conversion", { params }),
  getWonLostReport: (params = {}) => api.get("/crm/reports/won-lost", { params }),
  getLeadConversionReport: (params = {}) => api.get("/crm/reports/lead-conversion", { params }),
  getActivityReport: (params = {}) => api.get("/crm/reports/activities", { params }),
  exportExcel: (reportType, params = {}) => api.get(`/crm/reports/${reportType}/export/excel`, { params, responseType: 'blob' }),
  exportPdf: (reportType, params = {}) => api.get(`/crm/reports/${reportType}/export/pdf`, { params, responseType: 'blob' }),
};

/**
 * CRM Global Search
 */
export const crmSearchApi = {
  searchLeads: (query, params = {}) => api.get("/crm/search/leads", { params: { q: query, ...params } }),
  searchCompanies: (query, params = {}) => api.get("/crm/search/companies", { params: { q: query, ...params } }),
  searchContacts: (query, params = {}) => api.get("/crm/search/contacts", { params: { q: query, ...params } }),
  searchGlobal: (query, params = {}) => api.get("/crm/search/global", { params: { q: query, ...params } }),
};

/**
 * CRM Notification APIs
 */
export const crmNotificationApi = {
  getAll: (params = {}) => api.get("/crm/notifications", { params }),
  markAsRead: (id) => api.post(`/crm/notifications/${id}/read`),
  markAllAsRead: () => api.post("/crm/notifications/read-all"),
  getUnreadCount: () => api.get("/crm/notifications/unread-count"),
};

const crmApi = {
  leads: crmLeadApi,
  myLeads: crmMyLeadsApi,
  indiaMart: crmIndiaMartLeadApi,
  companies: crmCompanyApi,
  contacts: crmContactApi,
  followups: crmFollowupApi,
  calls: crmCallApi,
  opportunities: crmOpportunityApi,
  pipelineStages: crmPipelineStageApi,
  whatsapp: crmWhatsAppApi,
  campaigns: crmCampaignApi,
  marketingCampaigns: crmMarketingCampaignApi,
  dashboard: crmDashboardApi,
  reports: crmReportsApi,
  search: crmSearchApi,
  notifications: crmNotificationApi,
};

export default crmApi;